import React from 'react';

import { CONTRIBUTION_STATUS_BADGES, getContributionStatus } from '~support-at-home/lib/contributionStatus';

import LookupStatusBadge from '~components/LookupStatusBadge';
import { Row } from '~components/table-view';

interface ComponentProps {
  row: Row;
  today: string;
}

// Nothing until the row has a start date, so a blank new row does not claim to be Current.
const ContributionStatusBadge: React.FC<ComponentProps> = ({ row, today }) => {
  if (!row?.start_date) return null;

  const tag = getContributionStatus(row.start_date, row.end_date, today);
  return <LookupStatusBadge status={CONTRIBUTION_STATUS_BADGES[tag]} id={`contribution-status-${row.id}`} />;
};

export default ContributionStatusBadge;
